/* eslint-disable import/prefer-default-export */
import * as types from '../action.types';
import { getSettings, setSettings} from '../../services/settings.service';


const fetchSettingsSuccess = data => ({
  type: types.FETCH_SETTINGS_SUCCESS,
  payload: data,
});


const updateSettingsHideArchivedFilesSuccess = (hide) => ({
  type: types.UPDATE_SETTINGS_HIDE_ARCHIVED_FILES_SUCCESS,
  payload: hide

});



export function fetchSettings() {
  return (dispatch) => {
    const settings = getSettings();

    dispatch(fetchSettingsSuccess(settings));

    return settings;

  };
}

export function updateSettingsHideArchivedFiles(hide) {
  return (dispatch) => {
    const settings = getSettings();
    settings.hideArchivedSessions = hide;
    setSettings(settings);
    dispatch(updateSettingsHideArchivedFilesSuccess(hide))
  }
}
